// src/styles/GlobalStyles.js
import {createGlobalStyle} from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :root {
    --primary-font: 'Philosopher';
  }

  html, body {
    min-width: 320px;
    height: 100%;
    font-family: var(--primary-font), sans-serif;
    scroll-behavior: smooth;

  }

  body {
    background-image: url("/assets/background/bg_01.webp");
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
  }

  body.arabic {
    zoom: 100.5%;

  }

  body.arabic::after {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.15); /* Passe den Wert an, um den gewünschten Effekt zu erzielen */
    pointer-events: none;
    z-index: 9999;
  }

  img {
    display: unset !important;
  }

  a {
    color: unset;
    text-decoration: none;
  }

  a:hover {
    color: var(--link-hover-color) !important;
  }

  input {
    border: none;
    border-radius: 0;
    margin: 5px auto;
    background-color: transparent !important;
    background-image: url("/assets/ui/input.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    color: #ded0d5 !important;
    font-size: 10pt;
    height: 35px;
    width: 100%;
    padding: 0px 17% !important;
  }

  .form-control {
    border: none !important;
  }

  .form-label {
    margin: 0 !important;
  }

  .dropdown-menu {
    border-radius: 3px;
  }

  .dropdown-menu a {
    color: #fff !important;
    font-size: 11pt;
  }

  button {
    height: 66px;
    width: 160px;
    text-align: center;
    color: #fff;
    font-size: 10pt;
    padding: 0 20px;
    border: none;
    border-radius: 0;
    background-image: url("/assets/ui/btn.png");
    background-repeat: no-repeat;
    background-position: center;
    background-color: transparent !important;
    background-size: 100% 100%;
    opacity: 0.8;
    font-weight: bold;
    max-width: 250px;
    text-transform: uppercase;
  }

  button:hover {
    opacity: 1;
  }

  table {
    border-color: #261d12 !important;
  }


  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #140404;
  }

  ::-webkit-scrollbar-thumb {
    background: #e03939;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #f94141;
  }
`;

export default GlobalStyles;
